// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TopPanel_TopPanel__v9pTK {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #aeaeae;
  padding: 10px;
}
.TopPanel_TopPanel__v9pTK .TopPanel_Logo__GiWxX {
  width: 56px;
  height: 50px;
  cursor: pointer;
}
.TopPanel_TopPanel__v9pTK .TopPanel_Logo__GiWxX img {
  object-fit: fill;
  object-position: center;
  width: 100%;
  height: 100%;
}
.TopPanel_TopPanel__v9pTK .TopPanel_UserData__d0N_J {
  display: flex;
  margin: 0 20px 0 auto;
}
.TopPanel_TopPanel__v9pTK .TopPanel_UserData__d0N_J .TopPanel_Avatar__IIIXr {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px solid #228be6;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 2px;
  margin: 0 20px 0 0;
  background: #fff3df;
  font-weight: bold;
}
.TopPanel_TopPanel__v9pTK .TopPanel_UserData__d0N_J .TopPanel_Info__vdtla {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.TopPanel_TopPanel__v9pTK .TopPanel_UserData__d0N_J .TopPanel_Info__vdtla .TopPanel_Name__jsrcx {
  font-size: 14px;
  line-height: 17px;
}
.TopPanel_TopPanel__v9pTK .TopPanel_UserData__d0N_J .TopPanel_Info__vdtla .TopPanel_Email__Knj50 {
  font-size: 12px;
  line-height: 15px;
}
.TopPanel_TopPanel__v9pTK .TopPanel_UserData__d0N_J .TopPanel_Info__vdtla .TopPanel_Phone__P3E1I {
  font-size: 12px;
  line-height: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/TopPanel/TopPanel.module.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;EACA,aAAA;AAAJ;AAEI;EACI,WAAA;EACA,YAAA;EACA,eAAA;AAAR;AAEQ;EACI,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAAZ;AAII;EACI,aAAA;EACA,qBAAA;AAFR;AAIQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBChCE;EDiCF,iBAAA;AAFZ;AAKQ;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;AAHZ;AAKY;EACI,eAAA;EACA,iBAAA;AAHhB;AAMY;EACI,eAAA;EACA,iBAAA;AAJhB;AAOY;EACI,eAAA;EACA,iBAAA;AALhB","sourcesContent":["@use '../../variables.scss' as *;\n.TopPanel {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #aeaeae;\n    padding: 10px;\n\n    .Logo {\n        width: 56px;\n        height: 50px;\n        cursor: pointer;\n\n        img {\n            object-fit: fill;\n            object-position: center;\n            width: 100%;\n            height: 100%;\n        }\n    }\n\n    .UserData {\n        display: flex;\n        margin: 0 20px 0 auto;\n\n        .Avatar {\n            width: 50px;\n            height: 50px;\n            border-radius: 50%;\n            border: 1px solid $color-blue;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            letter-spacing: 2px;\n            margin: 0 20px 0 0;\n            background: $color-peach;\n            font-weight: bold;\n        }\n\n        .Info {\n            display: flex;\n            justify-content: center;\n            flex-direction: column;\n\n            .Name {\n                font-size: 14px;\n                line-height: 17px;\n            }\n\n            .Email {\n                font-size: 12px;\n                line-height: 15px;\n            }\n\n            .Phone {\n                font-size: 12px;\n                line-height: 15px;\n            }\n        }\n\n        .EscapeButton {\n        }\n    }\n}\n","$box-shadow-default: 0 2px 10px rgba(0, 0, 0, 0.5);\n$color-red: #ff0000;\n$color-white: #ffffff;\n$color-blue: #228be6;\n$color-peach: #fff3df;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TopPanel": `TopPanel_TopPanel__v9pTK`,
	"Logo": `TopPanel_Logo__GiWxX`,
	"UserData": `TopPanel_UserData__d0N_J`,
	"Avatar": `TopPanel_Avatar__IIIXr`,
	"Info": `TopPanel_Info__vdtla`,
	"Name": `TopPanel_Name__jsrcx`,
	"Email": `TopPanel_Email__Knj50`,
	"Phone": `TopPanel_Phone__P3E1I`
};
export default ___CSS_LOADER_EXPORT___;
